import { Box } from "@twilio-paste/core/box";
import { css, styled } from "@twilio-paste/styling-library";

export const ContentContainer = styled(Box)(() =>
    css({
        gridArea: "cont",
        paddingLeft: ["space0", "space0", "space200"],
        paddingRight: ["space0", "space0", "space200", "space0"],
        overflowWrap: "break-word"
    })
);
